module.exports = __webpack_public_path__ + "img/V58.1161a95f.jpg";